import { LoyaltyFeedCardType } from '@fgb/core';

/* ================================
 * Card Type Registry
 * ================================ */

/**
 * Loyalty card type registry for components
 */
export const componentCardTypes = new Set([
  LoyaltyFeedCardType.VoucherCode,
  LoyaltyFeedCardType.Poll,
  LoyaltyFeedCardType.Trivia,
  LoyaltyFeedCardType.Predictor,
]);

/**
 * Loyalty card type registry for reward items
 */
export const rewardCardTypes = new Set([
  LoyaltyFeedCardType.MarketplaceItem,
  LoyaltyFeedCardType.MarketplaceEvent,
  LoyaltyFeedCardType.Auction,
  LoyaltyFeedCardType.Lotto,
]);
